import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  useRef,
} from "react";

import api from "../helpers/api.js";

import * as Material from "@mui/material";

import CustomModal from "@components/CustomModal";
import ImageImportTool from "@components/ImageImportTool/index.js";
import { Input } from "@fragments";

import axios from "axios";

import { useNavigate } from "react-router-dom";

import Config, { token } from "../config.js";

import "./styles/auth-context.css";

const AuthContext = createContext({ signed: false });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const [profileModalOpen, setProfileModalOpen] = useState(false);

  const navigate = useNavigate();

  window.navigate = navigate;

  useEffect(() => {
    if (loading) {
      handleInitiate();
    }
  }, [loading]);

  useEffect(() => {
    window.signed = !!user;
  }, [user]);

  async function handleInitiate() {
    const token = localStorage.getItem("token");

    var url = new URL(window.location.href);
    var response = url.searchParams.get("response");

    if (response) {
      let decoded = atob(response.replace(/ /g, "+"));
      try {
        decoded = decodeURIComponent(escape(decoded));
      } catch (e) { }

      const token = JSON.parse(decoded).token;

      localStorage.setItem("token", token);
      window.location.href = window.location.href.split("?")[0];
      return;
    }

    if (token) {
      configApi();

      const user = await initializeUser();

      if (!user) {
        handleGoToAuth();
      } else {
        setLoading(false);
      }
    } else {
      handleGoToAuth();
    }
  }

  function handleGoToAuth() {
    const currentUrl = window.location.href;
    const baseAuthUrl = Config.auth.split('?')[0];
    window.location.href = `${baseAuthUrl}?redirect_uri=${encodeURIComponent(currentUrl)}`;
  }

  async function initializeUser() {
    try {
      const { data } = await api.get("user");
      console.log("User loaded", data);

      if (!data?.id) return null;

      setUser({ ...data });
      setLoading(false);

      return data;
    } catch (e) {
      console.log(e);
    }
  }

  function configApi() {
    try {
      axios.defaults.baseURL = Config.apiEndpoint;

      const token = localStorage.getItem("token");

      axios.defaults.headers.common = {
        Authorization: `Bearer ${token}`,
      };
      axios.defaults.headers.withCredentials = true;
    } catch (e) {
      console.log(e);
    }
  }

  async function login(email, password) {
    try {
      const loginResult = await axios.get(Config.apiEndpoint + "/auth/login", {
        params: { email, password },
      });

      if (loginResult.data.token) {
        Config.apiToken = loginResult.data.token;
        axios.defaults.baseURL = Config.apiEndpoint;
        axios.defaults.headers.common = {
          Authorization: `Bearer ${loginResult.data.token}`,
        };

        localStorage.setItem("@user", JSON.stringify(loginResult.data.user));
        localStorage.setItem("token", loginResult.data.token);

        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function signOut() {
    if (loading || !window.signed) return;
    localStorage.clear();
    setTimeout(() => {
      window.navigate("/");
      window.location.reload();
    }, 200);
  }

  window.logout = signOut;

  async function handleCreateAccount(values) {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const partShid = urlParams.get("part_shid");

      if (partShid) values.part_shid = partShid;

      const loginResult = await axios.post(
        Config.apiEndpoint + "/auth/signin",
        values
      );

      if (loginResult.data.success) {
        await login(values.email, values.password);
        window.location.href = "/";
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
    }

    return false;
  }

  function handleOpenProfileConfigModal() {
    setProfileModalOpen(true);
  }
  function onUserUpdated(info) {
    localStorage.setItem("@user", JSON.stringify({ ...user, ...info }));
    setUser({ ...user, ...info });
    setProfileModalOpen(false);
    window.setSnackbar("Seu perfil foi atualizado com sucesso");
  }

  return (
    <AuthContext.Provider
      value={{
        signed: !!user,
        user,
        signOut,
        login,
        loading,
        handleCreateAccount,

        handleOpenProfileConfigModal,
      }}
    >
      {loading ? <></> : children}

      <ProfileConfigModal
        key={Math.random()}
        onUpdated={onUserUpdated}
        open={profileModalOpen}
        onClose={() => {
          setProfileModalOpen(false);
        }}
      />
    </AuthContext.Provider>
  );
};

export default AuthContext;

export function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider.");
  }

  return context;
}

function ProfileConfigModal({ open, onClose, onUpdated }) {
  const { user } = useAuth();

  const [banner, setBanner] = useState(user?.avatar);
  const [username, setUsername] = useState(user?.username);

  const [loading, setLoading] = useState(false);

  async function handleSubmit() {
    if (username?.length < 8) {
      window.setSnackbar(
        "Insira um nome de usuário com no mínimo 8 caracteres"
      );
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const { data } = await api.post("profile", {
        username,
      });

      if (data.success) onUpdated({ username });

      console.log(data);
    } catch (e) {
      console.log(e);
    }

    setLoading(false);
  }

  async function uploadAvatar(imageBase64) {
    setLoading(true);
    try {
      const { data } = await api.post("user/avatar", {
        image: imageBase64.split(',')[1],
      });

      if (data.success) onUpdated({ avatar: data.path });

      console.log(data);
    } catch (e) {
      console.log(e);
    }

    setLoading(false);
  }

  return (
    <>
      <CustomModal
        maxWidth={380}
        bottomButtonCancelText="Cancelar"
        bottomButtonSumbitText="Salvar perfil"
        handleSubmit={handleSubmit}
        hideSecondaryButton={false}
        title={"Configurar perfil"}
        handleClose={onClose}
        loading={loading}
        open={open}
        modalClass="config-profile-modal"
        width="100%"
        bodyWrapperStyle={{}}
        bodyComponent={
          <div className="profile-config-modal px-3">
            <h4 className=" bold mt-3 mb-1">Sua foto de perfil</h4>
            {!banner && <span className=" mb-1">Nenhuma foto selecionada</span>}
            <ImageImportTool
              src={banner}
              onCrop={(imageBase64) => {
                setBanner(imageBase64);
                uploadAvatar(imageBase64);
              }}
              size={120}
              rounded={true}
            />

            <Input.Text
              fullWidth
              helper="Insira seu nome de usuário"
              className="mt-3"
              placeholder="Seu nome de usuário"
              value={username}
              onInput={setUsername}
            />
          </div>
        }
      />
    </>
  );
}
